export const rootElement = document.getElementById('root');
